// extracted by mini-css-extract-plugin
export default {"container":"_19PylYv35j6d237YBPXulU","full":"h-hFJPMeSA36PulL7jB0X","abbr":"_3Jz57jgDzFAVYu6Dl4uleY"};